export default __webpack_public_path__ + "static/media/aurelia.eed243d2.svg";